<template>
  <vx-card>
    <form id="send-referral-form" autocomplete="off" @submit.prevent>
      <vs-row vs-justify="center" vs-align="center">
        <vs-col vs-w="11" class="py-10">
          <vs-row>
            <vs-col>
              <div class="vx-card__title mb-6"><h4 class="">{{ $t('send_referral.claimant.title') }}</h4></div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col>
              <vs-row>
                <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2" v-if="caseManagers.length>0">
                  <vs-row>
                    <vs-col vs-w="3">
                      <span> Referring on behalf of <span class="text-danger">*</span></span>
                    </vs-col>
                    <vs-col vs-w="9">
                      <vs-select
                        filter
                        name="behalfOf"
                        class="w-full"
                        autocomplete
                        placeholder="Begin typing name to search list of users"
                        v-model="caseManager"
                        :multiple="false"
                        :options="caseManagers"
                        v-validate="'required'"
                        :danger="errors.has('behalfOf')"
                        danger-text="The Referring on behalf of field is required"
                      >
                      <template #message-danger>
                        Required
                      </template>
                        <vs-select-item
                          v-for="(manager, index) in caseManagers"
                          :key="index"
                          :text="manager.fullName"
                          :value="manager"
                        />
                      </vs-select>
                    </vs-col>
                  </vs-row>
                </vs-col>
                <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2" v-if="caseManagers.length>0">
                </vs-col>
                <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                  <vs-row>
                    <vs-col vs-w="3">
                      <span>{{ $t('send_referral.claimant.fields.firstname') }} <span class="text-danger">*</span></span>
                    </vs-col>
                    <vs-col vs-w="9">
                      <vs-input class="w-full"
                                :autocomplete="'nope'"
                                name="firstname"
                                :data-vv-as="$t('send_referral.claimant.fields.firstname')"
                                v-model="form.claimant.firstname"
                                v-validate="'required|min:2|max:50'"
                                :danger="errors.has('firstname')"
                                :danger-text="errors.first('firstname')"></vs-input>
                    </vs-col>
                  </vs-row>
                </vs-col>
                <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                  <vs-row>
                    <vs-col vs-w="3">
                      <span>{{ $t('send_referral.claimant.fields.lastname') }} <span class="text-danger">*</span></span>
                    </vs-col>
                    <vs-col vs-w="9">
                      <vs-input class="w-full"
                                :autocomplete="'nope'"
                                name="lastname"
                                :data-vv-as="$t('send_referral.claimant.fields.lastname')"
                                v-model="form.claimant.lastname"
                                v-validate="'required|min:2|max:50'"
                                :danger="errors.has('lastname')"
                                :danger-text="errors.first('lastname')"></vs-input>
                    </vs-col>
                  </vs-row>
                </vs-col>
                <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                  <vs-row>
                    <vs-col vs-w="3">
                      <span>{{ $t('send_referral.claimant.fields.email') }} <span class="text-danger">*</span></span>
                    </vs-col>
                    <vs-col vs-w="9">
                      <vs-input class="w-full"
                                :autocomplete="'nope'"
                                name="email"
                                :data-vv-as="$t('send_referral.claimant.fields.email')"
                                v-model="form.claimant.email"
                                v-validate="'required|email|max:100|uniqueEmail'"
                                data-vv-delay="1000"
                                :danger="errors.has('email')"
                                :danger-text="errors.first('email')"></vs-input>
                    </vs-col>
                  </vs-row>
                </vs-col>
                <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                  <vs-row>
                    <vs-col vs-w="3">
                      <span>{{businessUnitLabel && businessUnitLabel.businessLabel ? businessUnitLabel.businessLabel : $t('send_referral.claimant.fields.businessUnit') }}</span>
                    </vs-col>
                    <vs-col vs-w="9" v-if="businessUnits">
                      <vs-select class="w-full"
                                 :autocomplete="false"
                                 v-model="form.action.businessUnitId">
                        <vs-select-item :value="null" :text="$t('send_referral.claimant.fields.noChoice')"></vs-select-item>
                        <vs-select-item v-for="businessUnit in businessUnits.$getEmbedded('business-units')" :key="businessUnit.id"
                                        :value="businessUnit.id"
                                        :text="businessUnit.name"></vs-select-item>
                      </vs-select>
                    </vs-col>
                  </vs-row>
                </vs-col>

                <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                  <vs-row>
                    <vs-col vs-w="3">
                      <span>{{ $t('send_referral.claimant.fields.profession') }}</span>
                    </vs-col>
                    <vs-col vs-w="9" v-if="professions">
                      <vs-select class="w-full"
                                 :autocomplete="false"
                                 v-model="form.action.professionId">
                        <vs-select-item :value="null" :text="$t('send_referral.claimant.fields.noChoice')"></vs-select-item>
                        <vs-select-item v-for="profession in professions.$getEmbedded('professions')" :key="profession.id" :value="profession.id"
                                        :text="profession.name"></vs-select-item>
                      </vs-select>
                    </vs-col>
                  </vs-row>
                </vs-col>

                <vs-col v-if="isCaseManagerTeamOn" vs-lg="6" vs-sm="12" class="px-5 py-2">
                  <vs-row>
                    <vs-col vs-w="3">
                      <span>{{ hqTeamLabel }} <span class="text-danger">*</span></span>
                    </vs-col>
                    <vs-col vs-w="9" v-if="teamGroups">
                      <vs-select class="w-full"
                                 name="team"
                                 :data-vv-as="hqTeamLabel"
                                 autocomplete
                                 v-validate="'required'"
                                 v-model="form.action.hqTeamId"
                                 :danger="errors.has('team')"
                                 :danger-text="errors.first('team')">
                        <vs-select-item :value="null" :text="$t('send_referral.claimant.fields.selectOption')"></vs-select-item>
                        <template v-if="teamGroups.length === 1">
                          <vs-select-item v-for="team in teamGroups[0].teams" :key="team.id" :value="team.id" :text="team.name"></vs-select-item>
                        </template>
                        <template v-else>
                          <div v-for="group in teamGroups" :key="group.groupName">
                            <vs-select-group :title="group.groupName">
                              <vs-select-item v-for="team in group.teams" :key="team.id" :value="team.id" :text="team.name"></vs-select-item>
                            </vs-select-group>
                          </div>
                        </template>
                      </vs-select>
                    </vs-col>
                  </vs-row>
                </vs-col>
              </vs-row>
            </vs-col>
          </vs-row>
          <vs-row class="mt-10">
            <vs-col>
              <div class="vx-card__title mb-6"><h4 class="">{{ $t('send_referral.claim.title') }}</h4></div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col>
              <vs-row>
                <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                  <vs-row>
                    <vs-col vs-w="3">
                      <span>{{ userIdLabel }} <span class="text-danger">*</span></span>
                    </vs-col>
                    <vs-col vs-w="9">
                      <vs-input class="w-full"
                                :autocomplete="'nope'"
                                name="claimNumber"
                                :data-vv-as="userIdLabel"
                                data-vv-delay="1000"
                                v-model="form.claim.claimNumber"
                                v-validate="'required|min:1|max:25|validateClaimNumber'"
                                :danger="errors.has('claimNumber')"
                                :danger-text="errors.first('claimNumber')"
                                :description-text="hint"></vs-input>
                    </vs-col>
                  </vs-row>
                </vs-col>
                <vs-col v-if="showPolicyNumberLabel" vs-lg="6" vs-sm="12" class="px-5 py-2">
                  <vs-row>
                    <vs-col vs-w="3">
                      <span>
                        {{ policyNumberLabel }}
                        <span v-if="policyNumberRequired" class="text-danger">*</span>
                      </span>
                    </vs-col>
                    <vs-col vs-w="9">
                      <vs-input class="w-full"
                                :autocomplete="'nope'"
                                name="policyNumber"
                                :data-vv-as="$t('send_referral.claim.fields.policyNumber')"
                                v-model="form.claim.policyNumber"
                                v-validate="policyNumberRequired ? 'required|max:25' : 'max:25'"
                                :danger="errors.has('policyNumber')"
                                :danger-text="policyNumberRequired ? (policyNumberLabel + ' is required') : errors.first('policyNumber')"></vs-input>
                    </vs-col>
                  </vs-row>
                </vs-col>
              </vs-row>
            </vs-col>
          </vs-row>
          <vs-row class="mt-10">
            <vs-col>
              <div class="vx-card__title mb-6"><h4 class="">{{ $t('send_referral.action.title') }}</h4></div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col>
              <vs-row>
                <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                  <vs-row v-if="accessCodes">
                    <vs-col vs-w="3">
                      <span>{{ $t('send_referral.action.fields.program') }} <span class="text-danger">*</span></span>
                    </vs-col>
                    <vs-col vs-w="9">
                      <vs-select class="w-full"
                                 :autocomplete="false"
                                 name="program"
                                 :data-vv-as="$t('send_referral.action.fields.program')"
                                 v-model="form.action.accessCodeId"
                                 v-validate="'required'"
                                 @change="loadLocales()"
                                 :danger="errors.has('program')"
                                 :danger-text="errors.first('program')"
                                 :description-text="selectedProgramDescription">
                        <vs-select-item v-for="accessCode in accessCodes.$getEmbedded('access-codes')" :key="accessCode.id" :value="accessCode.id"
                                        :text="accessCode.name"></vs-select-item>
                      </vs-select>
                    </vs-col>
                  </vs-row>
                </vs-col>
                <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2"
                        v-if="selectedProgram && (selectedProgram !== 'MENTAL_FITNESS')">
                  <vs-row>
                    <vs-col vs-w="3">
                      <span>{{ $t('send_referral.action.fields.lastDayAtWork') }}</span>
                    </vs-col>
                    <vs-col vs-w="9">
                      <flat-pickr ref="picker"
                                  class="w-full"
                                  v-model="form.claim.lastDayAtWork"
                                  name="expiryDate"
                                  :config="{ enableTime: false,  maxDate: 'today' }"/>
                    </vs-col>
                  </vs-row>
                </vs-col>
                <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                  <vs-row>
                    <vs-col vs-w="3">
                      <span>{{ $t('send_referral.claimant.fields.language') }} <span class="text-danger">*</span></span>
                    </vs-col>
                    <vs-col vs-w="9" v-if="locales">
                      <vs-select class="w-full"
                                 :autocomplete="false"
                                 v-model="form.claimant.localeId">
                        <vs-select-item v-for="locale in locales.$getEmbedded('locales')" :key="locale.id"
                                        :value="locale.id"
                                        :text="locale.name"></vs-select-item>
                      </vs-select>
                    </vs-col>
                  </vs-row>
                </vs-col>
              </vs-row>
            </vs-col>
          </vs-row>

          <template v-if="prepareReferralCreateResource.$hasLink('training-products')">
            <vs-row class="mt-10">
              <vs-col>
                <div class="vx-card__title mb-6"><h4 class="">{{ $t('send_referral.training_assignment.title') }}</h4></div>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col>
                <vs-row>
                  <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                    <vs-row>
                      <vs-col vs-w="3">
                        <span>{{ $t('send_referral.training_assignment.fields.training.title') }}</span>
                      </vs-col>
                      <vs-col vs-w="9">
                        <sm-vs-select name="training"
                                      v-model="form.training.productId"
                                      :autocomplete="false"
                                      :data-vv-as="$t('send_referral.training_assignment.fields.training.title')"
                                      :disabled="!selectedAccessCode || !selectedLanguage || showTrainingPopup"
                                      :danger="errors.has('training')"
                                      :danger-text="errors.first('training')"
                                      clearable
                                      v-validate=""
                                      @focus="showTrainingPopup = true"
                                      @clear="onClearTraining">
                          <vs-select-item v-if="progressSelection" :value="progressSelection.product.id" :text="progressSelection.product.title"></vs-select-item>
                          <vs-select-item v-else :value="undefined" :text="$t('send_referral.training_assignment.fields.training.placeholder')"></vs-select-item>
                        </sm-vs-select>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                </vs-row>
              </vs-col>
            </vs-row>
          </template>

          <template v-if="prepareReferralCreateResource.$hasLink('checkup-cadence')">
            <vs-row class="mt-10">
              <vs-col>
                <div class="vx-card__title mb-6"><h4 class="">{{ $t('send_referral.checkup.title') }}</h4></div>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col>
                <vs-row>
                  <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                    <vs-row>
                      <vs-col vs-w="3">
                        <span>{{ $t('send_referral.checkup.fields.checkup_frequency') }}</span>
                      </vs-col>
                      <vs-col vs-w="9">
                        <vs-select class="w-full"
                                   :autocomplete="false"
                                   name="frequency"
                                   :data-vv-as="$t('send_referral.checkup.fields.checkup_frequency')"
                                   v-model="form.checkupCadence.checkupFrequency"
                                   v-validate=""
                                   @change="onSelectCheckupFrequency"
                                   :danger="errors.has('frequency')"
                                   :danger-text="errors.first('frequency')">
                          <vs-select-item v-for="(frequency, idxFrequency) in checkupFrequencyOptions" :key="idxFrequency" :value="frequency.value" :text="frequency.text"></vs-select-item>
                        </vs-select>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                  <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                    <vs-row>
                      <vs-col vs-w="3">
                        <span>{{ $t('send_referral.checkup.fields.checkup_amount') }}</span>
                      </vs-col>
                      <vs-col vs-w="9">
                        <vs-select class="w-full"
                                   :autocomplete="false"
                                   name="amount"
                                   :data-vv-as="$t('send_referral.checkup.fields.checkup_amount')"
                                   v-model="form.checkupCadence.checkupQuantityDue"
                                   v-validate=""
                                   @change="onSelectCheckupAmount"
                                   :danger="errors.has('amount')"
                                   :danger-text="errors.first('amount')">
                          <vs-select-item v-for="(amount, idxAmount) in checkupAmountOptions" :key="idxAmount" :value="amount.value" :text="amount.text"></vs-select-item>
                        </vs-select>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                </vs-row>
              </vs-col>
            </vs-row>
          </template>

          <vs-row class="mt-10">
            <vs-col>
              <div class="vx-card__title mb-6"><h4 class="">{{ $t('send_referral.message.title') }}</h4></div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col>
              <vs-row>
                <vs-col vs-w="12" class="px-5 py-2">

                  <vs-alert color="dark" class="mb-5" v-if="!form.claimant.firstname">
                    The message can be changed once you have entered a First name for your referral.
                  </vs-alert>
                  <vs-alert class="mb-5" color="warning"
                            v-else-if="personalizedMessage.localeId && personalizedMessage.localeId !== this.form.claimant.localeId">
                    Your message seems to be in a different language than the referral.
                    Please review your message or use the <a style="cursor:pointer;"
                                                 @click="onUpdateMessage(form.claimant.firstname, form.claimant.localeId,true)">default
                    message</a> for this language instead?

                  </vs-alert>
                  <vs-alert class="mb-5" color="warning"
                            v-else-if="personalizedMessage.firstname && personalizedMessage.firstname !== this.form.claimant.firstname">
                    Your seem to have changed the referral's First name. Please review your message or use the <a
                    style="cursor:pointer;"
                    @click="onUpdateMessage(form.claimant.firstname, form.claimant.localeId,true)">default
                    message</a> instead?

                  </vs-alert>
                  <vs-alert class="mb-5" color="dark" v-else-if="personalizedMessage.message">You have modified the
                    message.

                    Would you like to use the <a style="cursor:pointer;"
                                                 @click="onUpdateMessage(form.claimant.firstname, form.claimant.localeId,true)">default
                      message </a> instead?

                  </vs-alert>
                  <vs-alert v-else-if="!form.action.message" class="mb-5" color="dark">
                    Your referral will contain no personalized message. Are you sure, or do you want to use the <a
                    style="cursor:pointer;"
                    @click="onUpdateMessage(form.claimant.firstname, form.claimant.localeId,true)">default
                    message</a> instead?
                  </vs-alert>
                  <vs-alert v-else class="mb-5" color="dark">
                    This is the default message for the selected language.
                  </vs-alert>

                  <vs-textarea class="w-full" rows="8"
                               v-validate="''"
                               name="message"
                               v-model="form.action.message"
                               :disabled="!form.claimant.firstname"
                               :style="form.claimant.firstname?'':'background-color:#F1F1F1;'"
                               @input="onMessageChange">
                  </vs-textarea>
                </vs-col>
              </vs-row>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-w="4" class="px-5 py-2 text-right">
              <vs-button color="primary" type="flat" :disabled="loading || !isFormDirty || errors.any()" @click="onPreviewOpen">
                {{ $t('send_referral.buttons.preview') }}
              </vs-button>
            </vs-col>
            <vs-col vs-w="4" class="px-5 py-2 text-center">
              <vs-button size="large" color="primary" type="filled" :disabled="loading || !isFormDirty || errors.any()" @click="onSubmit">
                {{ $t('send_referral.buttons.send') }}
              </vs-button>
            </vs-col>
            <vs-col vs-w="4" class="px-5 py-2 text-left">
              <vs-button color="primary" type="border" :disabled="loading || !isFormDirty" @click="onCancel">
                {{ $t('send_referral.buttons.cancel') }}
              </vs-button>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-popup :active.sync="preview" fullscreen :title="$t('send_referral.buttons.preview')" class-content="content-full">
        <preview v-if="preview" :referrals-resource="prepareReferralCreateResource" :form="this.form"></preview>
      </vs-popup>
      <vs-popup :active.sync="showTrainingPopup" :title="''" class="send-referral-training" class-content="content-full" v-if="prepareReferralCreateResource.$hasLink('training-products') && selectedAccessCode && selectedLanguage">
        <member-progress-viewer :resource="prepareReferralCreateResource"
                                :access-code="selectedAccessCode.code"
                                :language="selectedLanguage"
                                sessionType="TRAINING"
                                relation="training-products"
                                embedded>
          <template #action="{ sessionType, productResource, sessionResource }">
            <div class="pt-1 pb-4">
              <vs-button @click="onProgressSelected({ type: sessionType, product: productResource, session: sessionResource })">
                Assign module
              </vs-button>
              <p class="starling-explanatory mt-2">Note: This will assign the entire module that this session lives in.</p>
            </div>
          </template>
        </member-progress-viewer>
      </vs-popup>
    </form>
  </vx-card>
</template>

<script>
import preview from '@/views/app/send_referral/preview';
import 'flatpickr/dist/flatpickr.css';
import { ResourceImpl } from 'hal-client';
import moment from 'moment';
import { Validator } from 'vee-validate';
import flatPickr from 'vue-flatpickr-component';
import VueSimpleSuggest from 'vue-simple-suggest';
import 'vue-simple-suggest/dist/styles.css';
import SmVsSelect from '@/components/starling/sm-vs-select/sm-vs-select.vue';
import MemberProgressViewer from '@/views/app/view_member/progress/member-progress-viewer';

/* eslint-disable security/detect-object-injection */
export default {
  name: 'send-referral',
  components: {
    preview,
    flatPickr,
    VueSimpleSuggest,
    SmVsSelect,
    MemberProgressViewer
  },
  props: {
    prepareReferralCreateResource: ResourceImpl
  },
  data () {
    return {
      userIdLabel: null,
      hint: null,
      loading: false,
      defaultMessages: null,
      professions: null,
      businessUnits: null,
      accessCodes: null,
      locales: null,
      preview: null,
      caseManager: null,
      caseManagers: [],
      teamGroups: null,
      isCaseManagerTeamOn: null,
      hqTeamLabel: null,
      businessUnitLabel: null,
      form: {
        claimant: {
          firstname: null,
          lastname: null,
          email: null,
          localeId: 1
        },
        claim: {
          policyNumber: null,
          claimNumber: null,
          lastDayAtWork: null
        },
        action: {
          accessCodeId: null,
          businessUnitId: null,
          professionId: null,
          message: null,
          caseManagerId: null,
          hqTeamId: null
        },
        training: {
          type: 'MODULE',
          productId: null
        },
        checkupCadence: {
          checkupFrequency: null,
          checkupQuantityDue: null
        }
      },
      policyNumberLabel: null,
      showPolicyNumberLabel: true,
      policyNumberMandatory: false,
      personalizedMessage: {
        localeId: null,
        message: null,
        firstname: null
      },
      checkupFrequencyOptions: [
        { value: null, text: this.$t('send_referral.checkup.frequency_options.member_discretion') },
        { value: 1, text: this.$t('send_referral.checkup.frequency_options.every_week') },
        { value: 2, text: this.$t('send_referral.checkup.frequency_options.two_weeks') },
        { value: 3, text: this.$t('send_referral.checkup.frequency_options.three_weeks') },
        { value: 4, text: this.$t('send_referral.checkup.frequency_options.four_weeks') }
      ],
      checkupAmountOptions: [
        { value: null, text: this.$t('send_referral.checkup.amount_options.member_discretion') },
        { value: 2, text: this.$t('send_referral.checkup.amount_options.qty_checkups', { qty: 2 }) },
        { value: 3, text: this.$t('send_referral.checkup.amount_options.qty_checkups', { qty: 3 }) },
        { value: 4, text: this.$t('send_referral.checkup.amount_options.qty_checkups', { qty: 4 }) },
        { value: 5, text: this.$t('send_referral.checkup.amount_options.qty_checkups', { qty: 5 }) },
        { value: 6, text: this.$t('send_referral.checkup.amount_options.qty_checkups', { qty: 6 }) },
        { value: 7, text: this.$t('send_referral.checkup.amount_options.qty_checkups', { qty: 7 }) }
      ],
      showTrainingPopup: false,
      progressSelection: null
    };
  },
  computed: {
    isFormDirty () {
      return Object.keys(this.fields).some(key => this.fields[key] && this.fields[key].dirty);
    },
    selectedAccessCode () {
      if (!this.form.action.accessCodeId || !this.accessCodes) {
        return null;
      }
      return this.accessCodes.$getEmbedded('access-codes').find(ac => {
        return ac.id === this.form.action.accessCodeId;
      });
    },
    selectedProgram () {
      return this.selectedAccessCode ? this.selectedAccessCode.program : null;
    },
    selectedProgramDescription () {
      return this.selectedAccessCode && this.selectedAccessCode.expiryDate ? `Expires : ${moment(this.selectedAccessCode.expiryDate).format('YYYY-MM-DD hh:mm A')}` : null;
    },
    selectedLanguage () {
      if (!this.form.claimant.localeId || !this.locales) {
        return null;
      }
      const locale = this.locales.$getEmbedded('locales').find(l => {
        return l.id === `${this.form.claimant.localeId}`;
      });
      return locale.language;
    },
    policyNumberRequired () {
      return this.showPolicyNumberLabel && this.policyNumberMandatory;
    }
  },
  watch: {
    loading (value) {
      if (value) {
        this.$vs.loading({
          container: '#send-referral-form',
          scale: 0.6
        });
      } else {
        this.$vs.loading.close('#send-referral-form > .con-vs-loading');
      }
    },
    'form.claimant.firstname' (value) {
      this.onUpdateMessage(value, this.form.claimant.localeId);
    },
    'form.claimant.localeId' (value) {
      this.onUpdateMessage(this.form.claimant.firstname, value);
    },
    showPolicyNumberLabel (val) {
      if (!val) this.form.claim.policyNumber = null;
    }
  },
  mounted () {
    this.form.action.hqTeamId = this.$store.state.router.profileResource.hqTeamId;
    this.prepareReferralCreateResource.$request().$get('user-id-label', null, {locale: 'en'}).then((res) => {
      this.userIdLabel = res.state().label;
      if (!this.userIdLabel) {
        this.userIdLabel = this.$t('send_referral.claim.fields.claimNumber');
        this.hint = this.$t('send_referral.claim.fields.claimNumberHint');
      }
    });
    if (this.prepareReferralCreateResource.$hasLink('business-unit-label')) {
      this.prepareReferralCreateResource.$request().$get('business-unit-label').then(res => {
        this.businessUnitLabel = res;
      });
    }
    if (this.prepareReferralCreateResource.$hasLink('case-managers')) {
      this.prepareReferralCreateResource.$request().$get('case-managers').then(res => {
        const managers = res.$getEmbedded('case-managers') || [];
        this.caseManagers = managers.map(manager => {
          return {
            ...manager,
            fullName: `${manager.firstname} ${manager.lastname}`
          };
        });
      }).catch(error => {
        console.error('Error fetching case managers:', error);
      });
    }
    this.prepareReferralCreateResource.$request().$get('professions').then(res => {
      this.professions = res;
    });
    this.prepareReferralCreateResource.$request().$get('default-message').then(res => {
      this.defaultMessages = res;
    });
    this.prepareReferralCreateResource.$request().$get('business-units').then(res => {
      this.businessUnits = res;
    });
    this.prepareReferralCreateResource.$request().$get('access-codes').then(res => {
      this.accessCodes = res;
      this.form.action.accessCodeId = this.accessCodes.$getEmbedded('access-codes')[0].id;

      this.prepareReferralCreateResource.$request().$get('locales', {'accessCodeId': this.form.action.accessCodeId}).then(res => {
        this.locales = res;
      });
    });
    this.prepareReferralCreateResource.$request().$get('hq-team-label', null, {locale: 'en'}).then((res) => {
      this.isCaseManagerTeamOn = res.state().enabled;
      this.hqTeamLabel = res.state().label || this.$t('send_referral.claimant.fields.team');

      if (this.isCaseManagerTeamOn) {
        if (this.prepareReferralCreateResource.$hasLink('hq-teams')) {
          this.prepareReferralCreateResource.$request().$get('hq-teams').then(res => {
            this.teamGroups = res;
          });
        }
      }
    });

    Validator.extend('uniqueEmail', {
      validate: value => {
        return new Promise(resolve => {
          return this.prepareReferralCreateResource.$request().$post('validate-email', {email: value}).then(() => {
            return resolve({
              valid: true
            });
          }, () => {
            return resolve({
              valid: false,
              data: {
                message: 'Email cannot be used, please contact members@starlingminds.com'
              }
            });
          });
        });
      },
      getMessage: (field, params, data) => data.message
    });

    Validator.extend('validateClaimNumber', {
      validate: value => {
        return new Promise(resolve => {
          return this.prepareReferralCreateResource.$request().$post('validate-claim-number', {claimNumber: value}).then(() => {
            return resolve({
              valid: true
            });
          }, () => {
            return resolve({
              valid: false,
              data: {
                message: 'ID exists for another member.'
              }
            });
          });
        });
      },
      getMessage: (field, params, data) => data.message
    });
    this.prepareReferralCreateResource.$request().$get('policy-number-label', null, {locale: 'en'}).then((res) => {
      this.policyNumberLabel = res.state().label;
      this.showPolicyNumberLabel = res.state().enabled;
      this.policyNumberMandatory = !!res.state().mandatory;
      if (!this.policyNumberLabel) {
        this.policyNumberLabel = this.$t('send_referral.claim.fields.policyNumber');
      }
      if (!this.showPolicyNumberLabel) {
        this.form.claim.policyNumber = null;
      }
    });
  },
  methods: {
    loadLocales () {
      this.prepareReferralCreateResource.$request().$get('locales', {'accessCodeId': this.form.action.accessCodeId}).then(res => {
        this.locales = res;
      });
    },
    onCancel () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Cancel referral',
        text: 'Are you sure you want to cancel this referral?',
        accept: () => {
          this.form = {
            claimant: {
              firstname: null,
              lastname: null,
              email: null
            },
            claim: {
              policyNumber: null,
              claimNumber: null,
              lastDayAtWork: null
            },
            action: {
              accessCodeId: this.accessCodes.$getEmbedded('access-codes')[0].id,
              businessUnitId: null,
              professionId: null,
              message: null
            },
            training: {
              type: 'MODULE',
              productId: null
            },
            checkupCadence: {
              checkupFrequency: null,
              checkupQuantityDue: null
            }
          };
          this.$validator.reset();
        }
      });
    },
    onSubmit () {
      this.$validator.validate().then(valid => {
        if (!valid) return;

        this.loading = true;
        if (this.caseManager) {
          this.form.action.caseManagerId = this.caseManager.id;
        }
        this.prepareReferralCreateResource.$request().$post('create', {}, this.form).then(res => {
          return this.$router.push({name: 'app-dashboard'}).then(() => {
            this.$vs.notify({
              title: 'Referral sent',
              text: `The claimant ${res.$getEmbedded('referral-claimant').firstname} ${res.$getEmbedded('referral-claimant').lastname} has been correctly referred to Starling Minds.`,
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success'
            });
          });
        }, () => {
          this.$vs.notify({
            time: 5000,
            title: 'An error occured',
            text: `The claimant ${this.form.claimant.firstname} ${this.form.claimant.lastname} has not been referred to Starling Minds. Please contact members@starlingminds.com.`,
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'danger'
          });
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    onPreviewOpen () {
      this.$validator.validate().then(valid => {
        if (!valid) return;

        if (this.caseManager) {
          this.form.action.caseManagerId = this.caseManager.id;
        }
        this.preview = true;
      });
    },
    onPreviewClose () {
      this.preview = false;
    },
    onUpdateMessage (firstname, localeId, force) {
      if (firstname && localeId && this.defaultMessages) {
        const parametrizedMessage = this.defaultMessages[localeId];
        const processedMessage = parametrizedMessage.replaceAll('${firstname}', firstname);
        if (!this.form.action.message || !this.personalizedMessage.message || force) {
          this.form.action.message = processedMessage;
          this.personalizedMessage.localeId = null;
          this.personalizedMessage.message = null;
          this.personalizedMessage.firstname = null;
        }
      }
    },
    onMessageChange () {
      if (this.form.action.message) {
        this.personalizedMessage.localeId = this.form.claimant.localeId;
        this.personalizedMessage.message = this.form.action.message;
        this.personalizedMessage.firstname = this.form.claimant.firstname;
      }
    },
    onSelectCheckupFrequency () {
      if (!this.form.checkupCadence.checkupFrequency) {
        this.form.checkupCadence.checkupQuantityDue = null;
      } else if (!this.form.checkupCadence.checkupQuantityDue) {
        this.form.checkupCadence.checkupQuantityDue = 2;
      }
    },
    onSelectCheckupAmount () {
      if (!this.form.checkupCadence.checkupQuantityDue) {
        this.form.checkupCadence.checkupFrequency = null;
      } else if (!this.form.checkupCadence.checkupFrequency) {
        this.form.checkupCadence.checkupFrequency = 1;
      }
    },
    onProgressSelected (selection) {
      this.showTrainingPopup = false;
      this.progressSelection = selection;
      this.form.training.productId = selection.product.id;
    },
    onClearTraining () {
      this.showTrainingPopup = false;
      this.form.training.productId = undefined;
      this.progressSelection = undefined;
    }
  }
};
</script>

<style lang="scss">
.content-full {
  width: 100%;
  height: 100%;
}

.send-referral-training .vs-popup {
  width: 90%;
  max-width: 1000px;
  height: 600px;
  display: flex;
  flex-direction: column;

  .vs-popup--content {
    margin: 0;
    padding: 0;
  }
}
</style>
